"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var PluggableElementBase = /*#__PURE__*/function () {
  function PluggableElementBase(args) {
    _classCallCheck(this, PluggableElementBase);
    this.name = args.name || 'UNKNOWN';
    this.maybeDisplayName = args.displayName;
  }
  _createClass(PluggableElementBase, [{
    key: "displayName",
    get: function get() {
      return this.maybeDisplayName || this.name;
    }
  }]);
  return PluggableElementBase;
}();
exports.default = PluggableElementBase;